import React from "react";
import { Box, Grid, GridProps, Typography } from "@material-ui/core";

interface ProductListProduct {
  title: string;
  description: string;
}

export type ProductListItemProps = {
  product: ProductListProduct;
} & React.HTMLAttributes<HTMLLIElement> & GridProps;

export const ProductListItem = ({
  children,
  product,
  ...props
}: ProductListItemProps) => (
  <Grid {...props}
        item
        xs={12}
        md={6}
  >
    <Box bgcolor='common.white'
         px={{xs: 2, md: 3}}
         py={{xs: 2, md: 3}}
         display='flex'
         flexDirection='column'
         height='100%'
    >
      <Typography component='h3'
                  variant='subtitle1'
                  color='primary'
      >
        {product.title}
      </Typography>

      <Box pt={{xs: 2, md: 2}}  mb={{xs: 3, md: 3}}>
        <Typography color='primary'>
          {product.description}
        </Typography>
      </Box>

      <Box textAlign='right' mt='auto'>
        {children}
      </Box>
    </Box>
  </Grid>
);
